webpackJsonp([161205263619399],{

/***/ 407:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---brand-design-fenton-a0e39f21c11f6a62c5ab.js